import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { yaMetrikaStore } from './YaMetrikaStore';

export const YaMetrikaExecutor = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    yaMetrikaStore.viewPage(window.location.href);
  }, [pathname]);

  return null;
};
